<template>
    <div class="my-4 font-medium leading-tight text-4 lg:text-6">
        <slot></slot>
    </div>
</template>